import { useState } from 'react';

const faqs = [
  {
    question: 'How much does it cost to use HomePro Dispatch?',
    answer: 'Our matching service is 100% free to homeowners. You only pay the contractor for the work performed. All our partners provide transparent, upfront quotes — no surprise fees, ever.',
  },
  {
    question: 'How does the dispatch process work?',
    answer: 'It\'s simple: select your service type, enter your zip code, and provide your contact info. Our system instantly routes your request to the highest-rated vetted contractor in your area. You\'ll receive a call within minutes — not hours or days.',
  },
  {
    question: 'Are the contractors licensed and insured?',
    answer: 'Yes — every contractor in our network has been pre-screened for valid licenses, insurance, and background checks before they\'re ever dispatched to a homeowner. We re-verify credentials regularly.',
  },
  {
    question: 'What areas do you service?',
    answer: 'We service all 50 states. Our nationwide database covers thousands of zip codes, and we have 24/7 availability. Same-day appointments can often be arranged for urgent issues.',
  },
  {
    question: 'What services do you offer?',
    answer: 'We cover Solar & Energy Optimization, Roofing & Exteriors, HVAC & Systems, Water & Disaster Cleanup, Safe Living & EMF Mitigation, and Plumbing & Drains — with more categories being added regularly.',
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-20 px-6 bg-[#F7F9FC]">
      <div className="max-w-screen-xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-16 items-start">
          {/* Left */}
          <div className="lg:w-2/5 w-full lg:sticky top-24">
            <p className="text-[#FF6B00] text-sm font-bold uppercase tracking-widest font-heading mb-3">Got Questions?</p>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-[#0A2540] font-heading leading-tight mb-5">
              Frequently Asked Questions.
            </h2>
            <p className="text-gray-500 text-sm font-body leading-relaxed mb-6">
              Can&apos;t find your answer here? Our dispatch team is available around the clock.
            </p>
            <a
              href="tel:+18669524010"
              className="inline-flex items-center gap-2 bg-[#FF6B00] text-white font-bold px-6 py-3 rounded-md text-sm hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-sm" />
              </div>
              Call 24/7: (866) 952-4010
            </a>
          </div>

          {/* Right: accordion */}
          <div className="lg:w-3/5 w-full flex flex-col gap-3">
            {faqs.map((faq, idx) => (
              <div
                key={faq.question}
                className={`bg-white rounded-xl border transition-all duration-200 overflow-hidden ${
                  openIdx === idx ? 'border-[#FF6B00]/30' : 'border-gray-100'
                }`}
              >
                <button
                  type="button"
                  className="w-full flex items-center justify-between gap-4 px-6 py-4 text-left cursor-pointer"
                  onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                  aria-expanded={openIdx === idx}
                  aria-controls={`faq-answer-${idx}`}
                  id={`faq-question-${idx}`}
                >
                  <span className={`font-bold text-sm font-heading ${openIdx === idx ? 'text-[#0A2540]' : 'text-gray-700'}`}>
                    {faq.question}
                  </span>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className={`${openIdx === idx ? 'ri-subtract-line text-[#FF6B00]' : 'ri-add-line text-gray-400'} text-base`} />
                  </div>
                </button>
                {openIdx === idx && (
                  <div
                    id={`faq-answer-${idx}`}
                    role="region"
                    aria-labelledby={`faq-question-${idx}`}
                    className="px-6 pb-5 text-sm text-gray-500 font-body leading-relaxed border-t border-gray-50 pt-3"
                  >
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
